import axios, { AxiosInstance } from 'axios';

let axiosCache: AxiosInstance | null = null;
const recsAxios = () => {
  if (!axiosCache) {
    axiosCache = axios.create({
      // istanbul ignore next
      get baseURL() {
        if (typeof window !== 'undefined')
          return window.__GLOBAL_RECS_STATE__.API_BASE_URL;
        // eslint-disable-next-line no-restricted-globals
        if (self.isSecureContext) return self.API_BASE_URL;
        return undefined;
      },
    });
  }
  return axiosCache;
};

export default recsAxios;
